import { render, staticRenderFns } from "./PlusButtonWithLink.vue?vue&type=template&id=39d5ced7"
import script from "./PlusButtonWithLink.vue?vue&type=script&lang=js"
export * from "./PlusButtonWithLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports